// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1786) return "static/chunks/1786-34e389fc676984e1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "f752a85c4e4376c3" + ".js";
};